import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "store-location-list" }
const _hoisted_2 = {
  key: 0,
  class: "ion-margin-horizontal"
}
const _hoisted_3 = {
  key: 2,
  class: "ion-margin ion-text-center"
}
const _hoisted_4 = {
  key: 3,
  class: "ion-margin"
}
const _hoisted_5 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_locationSearch = _resolveComponent("locationSearch")!
  const _component_dynamicSkeleText = _resolveComponent("dynamicSkeleText")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_locationLineItem = _resolveComponent("locationLineItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.nearLocations.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("h5", { class: "ion-text-center please-search-text" }, [
            _createTextVNode("Our menu and offers vary by location. "),
            _createElementVNode("br"),
            _createTextVNode("Search to find a Donatos near you:")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.searchBar)
      ? (_openBlock(), _createBlock(_component_locationSearch, {
          key: 1,
          class: "ion-hide-lg-down ion-margin-horizontal",
          "data-cy": "desktop-search"
        }))
      : _createCommentVNode("", true),
    (_ctx.searchError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.searchError), 1)
        ]))
      : (_ctx.searchProcessing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(10), (_, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "ion-margin-vertical ion-padding-top"
              }, [
                _createVNode(_component_dynamicSkeleText, {
                  element: "div",
                  childElements: _ctx.skeleText,
                  animate: i % 3 == 0
                }, null, 8, ["childElements", "animate"]),
                _createVNode(_component_ion_item_divider, { class: "ion-margin-vertical" })
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sort(_ctx.nearLocations), (location) => {
              return (_openBlock(), _createElementBlock("div", {
                key: location.id,
                class: "grey-highlight"
              }, [
                _createVNode(_component_locationLineItem, {
                  storeLocation: location,
                  clickable: "",
                  class: "ion-padding-vertical"
                }, null, 8, ["storeLocation"]),
                _createVNode(_component_ion_item_divider)
              ]))
            }), 128))
          ]))
  ]))
}